import pdf from 'vue-pdf';
import {
  Mesh,
  CanvasTexture,
  PlaneGeometry,
  MeshBasicMaterial,
  DoubleSide,
  // Group,
  } from "three";
  
export const IfcPlansMixin = {
  data: () => ({
    add_plan_dialog: false,
    active_plan: {
      id: -1,
      step: 0,
      steps_done: 0,
      scale: {
        geometry: {
          type: "Tube",
          radius: 0.1,
          points: [],
        },
        // point_one: {x: 0, y: 0, z: 0},
        // point_two: {x: 0, y: 0, z: 0},
        // length: 20,
        meter_per_pixel: 1//meter per pixel
      },
      offset: {x: 0, y: 0, z: 0},
      url: '',
    },
  }),
  // watch: {
  //   "active_plan.id"(val) {
  //     if (val !== -1 && this.active_plan.url === '') {
  //       this.$refs.uploadPlanInput.click();
  //     }
  //   },
  //   "active_plan.url"(val) {
  //     if (val !== '' && this.active_plan.id !== -1) {
  //       this.renderPlan(this.active_plan);
  //     }
  //   },
  //   "active_plan.step"(val) {
  //     switch (val) {
  //       case 1:
  //         //scale point 1

  //         break;
      
  //       default:
  //         break;
  //     }
  //   }
  // },
  methods: {
    // new
    createPlan(file) {
      // let plan_url = URL.createObjectURL(file);
      // this.createUDObject({
      //   url: [
      //     {[this.plan_parent_cache.type]: this.plan_parent_cache.id},
      //     {plans: ''},
      //     {showWithEntitiesNormalized: ''}
      //   ],
      //   url_prefix: `/projects/${this.project_id}/projectstructure`,
      //   u_object: {
      //     name: "New Plan",
      //     description: "",
      //     geometry: false,
      //     meter_per_pixel: 0.01,
      //     offset: {x: 0, y: 0, z: 0}, 
      //     // offset_x offset_y _offset_z
      //     url: plan_url,
      //     type: 'plans',
      //     parent: this.plan_parent_cache,
      //   },
      //   resp_data: {
      //     plans: [
      //       {
      //         name: "New Plan",
      //         description: "",
      //         geometry: false,
      //         meter_per_pixel: 0.01,
      //         offset: {x: 0, y: 0, z: 0},
      //         url: plan_url,
      //         type: 'plans',
      //         parent: this.plan_parent_cache,
      //       }
      //     ]
      //   },
      //   })
      this.uploadPlan({
        project_id: this.project_id,
        plan: file,
        parent_type: this.plan_parent_cache.type,
        parent_id: this.plan_parent_cache.id,
      }).then((id) => {
          console.log(this.$store.state.Ultra);
          console.log(id);
          this.initializePlan(id);
          this.active_tree_element_spatial = this.$store.state.Ultra.plans[id];
          // this.updateTreeOrderIndex(this.plan_parent_cache);
          })
    },
    // renderPlan(plan) {
    createPlanMesh(plan) {
      return new Promise(resolve2 => {
        // let self = this;
        console.log(plan.file);
        console.log(plan);
        this.loadPDF(plan.file).then(result => {
          console.log(result);
          // Fetch canvas' 2d context
          let context = result.canvas.getContext('2d');
          // Prepare object needed by render method
          let renderContext = {
            canvasContext: context,
            viewport: result.viewport
          };
    
          // Render PDF page
          let renderTask = result.page.render(renderContext);
          renderTask.promise.then(function () {
            let texture = new CanvasTexture(result.canvas);
            // let scale_factor;
            // if (!plan.scale) {
            //   scale_factor = 1;
            // } else {
            //   scale_factor = plan.scale.meter_per_pixel
            // }
            let plane_width = plan.meter_per_pixel * result.canvas.width;
            let plane_height = plan.meter_per_pixel * result.canvas.height;
            let geometry = new PlaneGeometry( plane_width, plane_height );
            // let material = new MeshBasicMaterial( {color: 0xffff00, side: DoubleSide} );
            let material = new MeshBasicMaterial({
              map: texture,
              side: DoubleSide,
            });
            geometry.rotateX(- Math.PI / 2);
            geometry.translate(0,plan.offset_z - 0.01,0);
            let plan_mesh = new Mesh( geometry, material );
            plan_mesh.name = `plan_${plan.id}`;
            // let group = new Group();
            // group.name = `plan_${plan.id}`;
            // group.add(plane);
            // // plane.rotation.x = - Math.PI / 2;
            // // plane.position.y = 2.7;
            // self.scene.add( group );
            resolve2(plan_mesh);
          });
        });
     });
    },
    loadPDF(url) {
      return new Promise(resolve => {
        let loading_task = pdf.createLoadingTask(url);
        // Asynchronous download PDF
        loading_task.promise.then(function(pdf) {
          return pdf.getPage(1);
        }).then(function(page) {
          // let factor = meter_per_pixel / 0.01;
          // Set scale (zoom) level
          let scale = 5;
    
          // Get viewport (dimensions)
          let viewport = page.getViewport({ scale: scale });
    
          // Get canvas#the-canvas
          let canvas = document.createElement('canvas');
  
          // Set dimensions to Canvas
          canvas.width = viewport.width;
          canvas.height = viewport.height;
    
          // canvas.style.height = "100%";
          // canvas.style.width = `${100 * self.plan_zoom}%`;
          resolve({canvas: canvas, viewport: viewport, page: page});
      });
    });
    },
    applPlanScale(plan, new_length, old_length) {
      if (new_length > 0 && old_length > 0) {
        let factor = new_length / old_length;
        let old_meter_per_pixel = plan.meter_per_pixel
  
        let new_meter_per_pixel = old_meter_per_pixel * factor;
        this.updateUObject({
          url: [
            {plans: this.active_tree_element_spatial.id},
          ],
          url_prefix: `/projects/${this.project_id}/projectstructure`,
          update: {
            meter_per_pixel: new_meter_per_pixel
          }
        });
        this.removeObjectByName(`plan_${this.active_tree_element_spatial.id}`,this.plans_group)
        this.initializePlan(this.active_tree_element_spatial.id);
        this.scaleUnstagedGeometry(this.edit_geom_mesh, this.edit_geom, factor);
        this.refreshHandles();
        this.edit_geom.path_length = this.calcPathLength(this.edit_geom).toFixed(2);
        console.log(this.edit_geom.path_length);
      }
    },
    planDetectRooms(plan, room_height) {
      return new Promise((resolve, reject) => {
        let plan_mesh = this.scene.getObjectByName(`plan_${plan.id}`);
        console.log(plan_mesh);
        let canvas = plan_mesh.material.map.image;
        // let image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");  // here is the most important part because if you dont replace you will get a DOM 18 exception.
        // let image_data_url = canvas.toDataURL("image/png");  // here is the most important part because if you dont replace you will get a DOM 18 exception.
        // let image_data_url = canvas.toDataURL();  // here is the most important part because if you dont replace you will get a DOM 18 exception.
        // create a new image element
        // let image = new Image();
        // // set the data URL as the image source
        // image.src = canvas.toDataURL();
        canvas.toBlob(blob => {
          this.planDetectRoomsCall({
            project_id: this.project_id,
            buildingstorey_id: plan.parent.id, 
            meter_per_pixel: plan.meter_per_pixel,
            height: room_height,
            plan_offset_x: (canvas.width / 2) * plan.meter_per_pixel,
            plan_offset_y: (canvas.height / 2) * plan.meter_per_pixel * -1,
            offset: {x: plan.offset_x, y: plan.offset_y, z: plan.offset_z},
            image: blob,
          }).then((ids) => {
            for (let i = 0; i < ids.length; i++) {
              this.initializeUnstagedElement(ids[i])
            }
            resolve();
          })
          .catch(() => {
            reject();
          })
        })
        
        // console.log(image_data_url);
        // window.location.href=image_data_url; // it will save locally 
        // console.log(canvas.width, canvas.height);
      });
    },
    setPlanVisibility(plan) {
      console.log(plan);
      this.scene.getObjectByName(`plan_${plan.id}`).visible = !plan.visible;
    },

    // old
    planTest(plan) {
      if (!this.plan) {
        let self = this;
        let url = URL.createObjectURL(plan);
    
        let loading_task = pdf.createLoadingTask(url);
        // Asynchronous download PDF
        loading_task.promise.then(function(pdf) {
          return pdf.getPage(1);
        })
        .then(function(page) {
          // Set scale (zoom) level
          let scale = 1;
    
          // Get viewport (dimensions)
          let viewport = page.getViewport({ scale: scale });
    
          // Get canvas#the-canvas
          let canvas = document.createElement('canvas');
    
          // Fetch canvas' 2d context
          let context = canvas.getContext('2d');
    
          // Set dimensions to Canvas
          canvas.width = viewport.width;
          canvas.height = viewport.height;
    
          // canvas.style.height = "100%";
          // canvas.style.width = `${100 * self.plan_zoom}%`;
    
          // Prepare object needed by render method
          let renderContext = {
            canvasContext: context,
            viewport: viewport
          };
    
          // Render PDF page
          let renderTask = page.render(renderContext);
          renderTask.promise.then(function () {
            let texture = new CanvasTexture(canvas);
            let geometry = new PlaneGeometry( 20, 20 );
            // let material = new MeshBasicMaterial( {color: 0xffff00, side: DoubleSide} );
            let material = new MeshBasicMaterial({
              map: texture,
              side: DoubleSide,
            });
            geometry.rotateX(- Math.PI / 2);
            geometry.translate(0,2.7,0);
            let plane = new Mesh( geometry, material );
            // plane.rotation.x = - Math.PI / 2;
            // plane.position.y = 2.7;
            self.scene.add( plane );
            self.plan = plane;
    
          });
        });
      } else {
        this.scene.remove(this.plan);
        this.plan = false;
      }
    },

    editPlan(id) {
      if (id === 'create') {
        //create new plan
        this.active_plan.id = 'create';
      } else {
        //copy plan
        this.active_plan = JSON.parse(JSON.stringify(this.$store.state.Ultra.plans[id]));
      }
      this.floorView();
      this.add_plan_dialog = true;
      this.addHandles({target: this.scene, points: this.active_plan.scale.points});
    },
    endEditPlan(save) {
      let id = this.active_plan.id;
      if (save) {
        //save it else cancel
        //if create save new id
      }
      this.freeView();
      this.add_plan_dialog = false;
      this.resetActivePlan();
      this.removeObjectByName(`plan_${this.active_plan.id}`);
      if (id !== 'create') {
        let plan = this.store.state.Ultra.plans[id];
        this.renderPlan(plan);
      }
    },
    resetActivePlan() {
      this.active_plan = {
        id: -1,
        step: 0,
        steps_done: 0,
        scale: {
          point_one: {x: 0, y: 0, z: 0},
          point_two: {x: 0, y: 0, z: 0},
          length: 10,
        },
        offset: {x: 0, y: 0, z: 10},
      };
    },
    editPlanPDF(file) {
      let url = URL.createObjectURL(file);
      this.loadPDF(url).then(result => {
        //set initial pixel ratio when first upload plan
        this.active_plan.scale.pixel_ratio = this.active_plan.scale.length / result.canvas.width;
        this.active_plan.file = url;
      });
    },
  }
}